import React from 'react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      role='status'
      aria-live='polite'
      className='fixed top-0 left-0 right-0 z-[60] bg-neutral-800 border-b border-border/40 px-4 py-2 text-center'
    >
      <p className='text-xs text-muted-foreground'>
        You're offline — showing last available data
      </p>
    </div>
  );
};
